import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import axios from "axios";
import { Button, message, Input, Form, Select, Checkbox } from "antd/lib";
import { useDispatch, useSelector } from "react-redux";
import { OnBoardDta } from "../../Redux/actions/OnboardAction";
// import { GetPosp } from "../../Redux/actions/NumBikeation";
// import { UatNav } from "../Navbar/UatNav";
import Logo from "../../images/logo-vibe.png";
import { VerifyOtp } from "./VerifyOtp";
import "./onboard.css";
import BackGround from "../../images/vibe_bg_img_new.jpg";

function OtpLogin() {
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const { Option } = Select;
  // const RemPass = useSelector((state) => state?.pass);
  const OTPData = useSelector((state) => state?.posp?.onboardOtp);
  const Posp = useSelector((state) => state?.posp?.Posp);
  // const [LogDetail, setLogDetail] = useState(RemPass);
  // const [email, setemail] = useState("");
  // const [password, setpassword] = useState("");
  // const [iserror, setiserror] = useState(false);
  const [loading, setloading] = useState(false);
  const [BaseUrl, setBaseURL] = useState("");
  const AccToken = Posp?.accessToken;
  const history = useHistory();
  useEffect(() => {
    const BASEURL = process.env.REACT_APP_UAT_BASE_URL;
    setBaseURL(BASEURL);
  }, []);

  const prefixSelector = (
    <Select
      style={{
        width: 70,
      }}
      defaultValue="+91"
    >
      <Option value="+91">+91</Option>
    </Select>
  );
  const OnRedirect = () => {
    history.push("/");
    dispatch({ type: "LOG_STATE" });
  };
  const handleSubmit = (values) => {
    console.log(values);
    console.log(BaseUrl);
    let post = {
      // name: values?.fullName,
      phonenumber: values?.phonenumber,
    };
    setloading(true);
    axios
      .post(`${BaseUrl}v1/posp/otp/send`, post)
      .then((res) => {
        console.log(res);
        const Udata = res?.data;
        console.log(Udata);
        message.success(Udata?.message);
        setloading(false);
        dispatch(
          OnBoardDta({
            name: values?.fullName,
            phone: post?.phonenumber,
            otpResp: Udata,
          })
        );
        // dispatch({ type: "RESET_CAR" });
        // dispatch({ type: "RESET_BIKE" });
        // history.push('/');
      })
      .catch((err) => {
        console.log(err.response);
        if (AccToken) {
          history.push("/profileDetails");
        } else if (err.response.data.message === "Unauthenticated.") {
          dispatch({ type: "LOGOUT_POSP" });
          history.push("/");
        }
        setloading(false);
        message.error(err?.response?.data?.message);
      });
    // } else {
    //   setiserror(true)
    // }
  };

  return (
    <>
      {/* <UatNav/> */}
      <div className="v-bg-posp">
        <div className="  d-flex justify-content-center h-100 align-items-center row">
          {/* <div className="">
        </div> */}
          <div className="left-c-section col-xl-5 col-lg-6 col-md-6">
            {/* <div>
            <img src={Logo} style={{ width: "185px" }}></img>
          </div>
          <h1>
            Become a Vibe Insurance PoSP/Advisor <br />& earn{" "}
            <span>Upto 50,000₹ / Month</span>{" "}
          </h1>
          <p style={{ fontSize: "20px" }}>Zero Investment Required.</p> */}
          </div>
          {OTPData?.otpResp?.message === "Otp sent to your phone number" ? (
            <VerifyOtp />
          ) : (
            <div className="right-section-on col-xl-5 col-lg-6 col-md-6">
              <div className="login-container-onboard">
                <div className="d-block text-center my-2">
                  <h4 className="mb-2" style={{ color: "#00000069" }}>
                    Verify Your Mobile Number
                  </h4>
                </div>
                <Form
                  onFinish={handleSubmit}
                  form={form}
                  requiredMark={false}
                  layout="vertical"
                >
                  <Form.Item
                    label="Name"
                    name="fullName"
                    rules={[
                      {
                        required: true,
                        message: "please input Name",
                      },
                    ]}
                  //initialValue={OwnerInfo?.Owner ? OwnerInfo?.Owner : vehicleDetail?.owner_name}
                  >
                    <Input style={{ width: "100%" }} placeholder="Enter Name" />
                  </Form.Item>
                  <Form.Item
                    label="Mobile Number"
                    name="phonenumber"
                    rules={[
                      {
                        pattern: /^([0|+[0-9]{1,5})?([6-9][0-9]{9})$/,
                        message: "Invalid Mobile No",
                      },
                      { required: true, message: "Enter Mobile No" },
                    ]}
                  >
                    <Input
                      maxLength={10}
                      addonBefore={prefixSelector}
                      placeholder="Enter Mobile Number (eg. 9876543210)"
                    ></Input>
                  </Form.Item>
                  <Form.Item
                    className="mb-0"
                    name="checkBox"
                    valuePropName="checked"
                    rules={[
                      {
                        validator: (_, value) =>
                          value
                            ? Promise.resolve()
                            : Promise.reject(
                              new Error(
                                "Please agree to the terms & conditions."
                              )
                            ),
                      },
                    ]}
                  >
                    <Checkbox>
                      By Continue Agree to the{" "}
                      <span
                        style={{
                          color: "#293890",
                          cursor: "pointer",
                          textDecoration: "underline",
                        }}
                        onClick={() => history.push("/become-posp")}
                      >
                        terms & conditions
                      </span>
                    </Checkbox>
                  </Form.Item>
                  <Form.Item className="mb-2">
                    <Button
                      type="primary"
                      htmlType="submit"
                      style={{
                        width: "100%",
                        background: "#293890",
                        border: "#293890",
                        marginTop: "3%",
                        maxHeight: "42px",
                        minHeight: "42px",
                      }}
                      loading={loading}
                    >
                      Continue
                    </Button>
                  </Form.Item>
                </Form>
                <div className="d-flex justify-content-between">
                  <p style={{ color: "#293890" }} className="mb-0">
                    Already Have Account ?
                  </p>
                  <a
                    style={{ color: "#293890" }}
                    onClick={() => OnRedirect()}
                  //   to='/OtpLogin'
                  >
                    Login
                  </a>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
}

export { OtpLogin };
